import axios from "axios";

const tokenServiceClient = axios.create({
    baseURL: import.meta.env.VITE_TOKEN_SERVICE_URL || "",
    headers: { "Content-Type": "application/json" },
});

tokenServiceClient.interceptors.response.use((response) => response.data);

export default tokenServiceClient;
